<!--eslint-disable-->
<sellerMenu class="float-left" />
<template>
  <div class="marketingList">
    <h2 class="f18 fb normal gray_2">拼团策略</h2>
    <div class="marketingList_main clear relative b_white f14">
      <div class="clear">
        <span class=" pull-left gray_2 f14">拼团活动列表</span>
        <div class=" pull-right clear">
          <el-button type="primary" class="f16" @click="toAddActivity"><span class="f22 lin_25">+</span> 添加拼团活动</el-button>
        </div>
      </div>
      <div class="box30"></div>
      <div class="marketing_table f14 t_center">
       <div class="table_main">
         <table cellpadding="0" cellspacing="0" class="marketing_table_head">
           <thead>
           <tr>
             <td width="200">活动名称</td>
             <td width="140">开始时间</td>
             <td width="140">结束时间</td>
             <td width="80">状态</td>
             <td width="" class="text-center">
               <span>操作</span>
             </td>
           </tr>
           </thead>
         </table>
         <table cellpadding="0" cellspacing="0" border="0">
           <tbody>
           <tr v-for="item in activityList" v-bind:key="item.id">
             <td width="200">{{item.title}}</td>
             <td width="140">{{item.startTimeStr}}</td>
             <td width="140">{{item.endTimeStr}}</td>
             <td width="80">{{item.activityStatus == 1 ? '未开始' : item.activityStatus == 2 ? '活动中' : '活动结束'}}</td>
             <td width="">
               <el-button @click="getActivityDetail(item)">查看</el-button>
               <el-button @click="copyLinks(item)">复制链接</el-button>
               <el-button v-if="item.activityStatus !== 2" @click="delActivity(item)">删除</el-button>
               <el-button v-if="item.activityStatus !== 2" @click="updateActivity(item)">编辑</el-button>
             </td>
           </tr>
           </tbody>
         </table>
       </div>
        <div class="box30"></div>
        <!--分页start-->
        <div class="pages text-right">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-sizes="[10, 20, 30]"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.totalCount">
          </el-pagination>
        </div><!--分页end-->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      activityList: [],
      pagination: {
        pageSize: 10,
        currentPage: 1,
        totalCount: 0,
      },
      dialogVisible: false,
      activityDetail: {},
      defaultShopId: "",
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {},
  mounted() {
    this.getShopDefault();
    this.getActivityList();
  },
  // 监听器
  filters: {},
  methods: {
    toAddMarketingDirect() {
      this.$router.push({
        path: "/mj/addMarketing/DIRECT",
      });
    },
    toAddActivity() {
      this.$router.push({
        path: "/mj/groupBooking",
      });
    },
    getActivityList() {
      this.$store
        .dispatch("group/groupActivity/getGroupActivityList", {
          pageNum: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
        })
        .then((data) => {
          if (data) {
            console.info(data);
            this.activityList = data.list;
            this.pagination.totalCount = data.paginator.totalCount;
          }
        });
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getActivityList();
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getActivityList();
    },
    // 删除
    delActivity(item) {
      this.$store.dispatch("group/groupActivity/delActivity", item.id).then((res) => {
        if (res !== null && res.code === "0") {
          this.$message.success("删除成功");
          this.getActivityList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    updateActivity(item) {
      this.$router.push({
        path: `/mj/groupBooking?activityId=${item.id}`,
      });
    },
    getActivityDetail(item) {
      this.$router.push({
        path: `/mj/groupBookingShow?activityId=${item.id}`,
      });
    },
    getShopDefault() {
      this.$store.dispatch("header/getShopDefault", {}).then((data) => {
        if (data && data.shopIdStr) {
          this.defaultShopId = data.shopIdStr;
        }
      });
    },
    copyLinks(item) {
      if (!item) {
        return;
      }
      const oInput = document.createElement("input");
      oInput.value = `${process.env.VUE_APP_APP}vm/group/goodList?shopId=${this.defaultShopId}&activityId=${item.id}`;
      document.body.appendChild(oInput);
      oInput.select();
      if (document.execCommand("Copy")) {
        document.execCommand("Copy");
        this.$message.success("复制成功");
      }
      oInput.style.display = "none";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "index";
</style>
